"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  vesselMovement: {
    title: '船舶动态&汇率',
    vesselName: '船舶名称',
    tips_1: '查询结果',
    tips_2: '黑色字体',
    tips_3: '为预计时间， ',
    tips_4: '蓝色字体',
    tips_5: '为已确定动态时间，',
    tips_6: '红色字体',
    tips_7: '为实际时间',
    tips_8: ' 船舶动态将于每日10：00,13：30、16：30更新最新消息,合作方的船舶动态更新可能会出现时间差,对于日本港口以下网址更为准确。',
    vesselNameShort: '船名',
    voyage: '航次',
    port: '港口',
    terminal: '码头',
    originalETA: '原计划到港日',
    originalETB: '原计划靠泊日',
    originalETD: '原计划出港日',
    eta: '到港时间',
    etb: '靠泊时间',
    etd: '离港时间',
    rate: '汇率',
    remark: '备注',
    updateTime: '更新时间',
    lastMonth: '上一月 |',
    nextMonth: ' 下一月'
  }
};